import type { WorldModule } from '../module';

export class AudioModule implements WorldModule {
  readonly id = 'audio' as const;
  constructor(private readonly setLoopSet: (s: 'short' | 'full') => Promise<void>) {}
  async build(level: string): Promise<void> { await this.setLoopSet(level === 'full' ? 'full' : 'short'); }
  dispose(): void { /* the next build replaces the set */ }
}
